
// Spolecne scripty seznamu WFL 
// JSindelka
namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class PodDokSpisListBasePage extends GContentBase<Gordic.Wfl.ListAC.DokSpisListBaseAC> 
    {
        public static InitList(content: GContentType<PodDokSpisListBasePage>): void
        {
            Gordic.Wfl.ListAC.WflListBaseAC.InitList(content);
            Wfl.ListAC.DokSpisListBaseAC.AddBaseActionsDokSpis(content)
            Gordic.Wfl.ListAC.DokSpisListBaseAC.EnabledAction(content);
        }

        public static CreateActionOpravaElPodani(content: GContentType<PodDokSpisListBasePage>, favorite?: boolean): GAction {
            var action = new GAction({
                name: Pod.Globals.ActionsName.opravaElPodani,
                icon: Gin.Icons.ActionEnum.editovat,
                caption: "jres:23900112", //RC 23900112 : Opravit profil podání
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content);
                    if (rowData) {
                        if (rowData.s_prij == 1)
                        {
                            Gordic.Pod.Dialogs.PodaniOpravaPisemnostiDlg(content, {
                                Ixp: rowData.ixp,
                                ModFormu: Interface.ModFormuPodaniEnum.OpravaElPodani,
                                TypPid: Wfl.Interface.TypPid.jizEvidovanyDokSpis
                            }).done(function () {

                            });
                        } else content.dialogs.warning("jres:23900113") //RC 23900113 : Nejedná se o cizí dokument.
                    }
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionStornovat(content: GContentType<PodDokSpisListBasePage>): GAction {
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Stornovat,
                icon: Gordic.Gin.Icons.ActionEnum.stornovat,
                caption: "jres:23900202", //RC 23900202 : Stornovat
                tooltip: "jres:23900202",
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    //var l_content = $.content<Gordic.Wfl.ListAC.WflListBaseAC>(this);
                    var l_SelectedIDs = Wfl.ListAC.WflListBaseAC.GetSelectedIxsDatZmena(content);
                    if (l_SelectedIDs.length > 0)
                    {
                        content.dialogs.confirm("jres:23900067", "jres:23900203" + Gin.Globals.Enums.UsedStrings.newLine + "jres:23900204").on("yes", (ev, obj) => { //RC 23900204 : Stornovány budou pouze dokumenty a spisy, které nejsou v redistribuci.

                            content.dialogs.prompt("", "jres:23900205") //RC 23900329 : Zadejte důvod zamítnutí převzetí
                                .on("ok", function (ev, duvod) {
                                    if (duvod != null && duvod.trim() != "") {
                                        content.TypProvedeneAkce = Wfl.Interface.TypAkce.stornovani;
                                        content.call<Gin.Interface.GResultInfo[]>("StornovatPod", { Selected: l_SelectedIDs, Duvod: duvod })
                                            .done(function (r) {
                                                Wfl.ListAC.WflListBaseAC.ResolveResultInfo(content, r, Wfl.Interface.TypAkce.stornovani, true)
                                            })
                                    }
                                });
                        });
                    } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(content);
                }
            });
            return action;
        }

        public static CreateActionVratitPoste(content: GContentType<PodDokSpisListBasePage>, favorite?: boolean): GAction {
            var action = new GAction({
                name: Pod.Globals.ActionsName.vratitPoste,
                icon: Gin.Icons.ActionEnum.vratit,
                caption: "jres:23900132", //RC 23900132 : Vrátit poště
                run: function (ev, ctx)
                {
                    content.dialogs.confirm("jres:23900067", "jres:23900133").on("yes", (ev, obj) => { //RC 23900067 : Dotaz

                        var l_asSelected = Wfl.ListAC.WflListBaseAC.GetSelectedIxsDatZmena(content);
                        if (l_asSelected.length > 0) {

                            Gin.Globals.ShowWaitLoadData(content);
                            content.call<Gordic.Gin.Interface.GResultInfo[]>("VratitPoste", { Selected: l_asSelected  })
                                .done(function (r)
                                {
                                    Wfl.ListAC.WflListBaseAC.ResolveResultInfo(content, r, Wfl.Interface.TypAkce.vraceni, true);
                                })
                                .always(function () {
                                    content.endOperation();
                                });

                        } else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(content);
                    });
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

    }
}


